/* ================================================================
   PRODUCT STATS BLOCK — JavaScript
   File: assets/product-stats-block.js
   Animates progress bars when they scroll into view
================================================================ */
(function () {
  'use strict';

  function animateBars(container) {
    var fills = container.querySelectorAll('.psb-stats__bar-fill');
    fills.forEach(function (fill, i) {
      var pct = parseFloat(fill.dataset.pct) || 0;
      /* Stagger each bar by 150ms */
      setTimeout(function () {
        fill.style.width = pct + '%';
      }, i * 150);
    });
  }

  function init() {
    var containers = document.querySelectorAll('.psb-stats');

    if (!containers.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateBars(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      containers.forEach(function (c) { observer.observe(c); });
    } else {
      /* Fallback — animate immediately */
      containers.forEach(animateBars);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor reload */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var c = e.target.querySelector('.psb-stats') || e.target.closest('.psb-stats');
    if (c) animateBars(c);
  });

})();
